import React from 'react';

const ListingSkeleton = () => {
  return (
    <div className="mx-auto sm:pt-6 max-w-7xl animate-pulse">
      {/* Image Carousel Skeleton */}
      <div className="w-full h-64 md:h-96 bg-gray-200 rounded-xl"></div>

      <div className="content-wrapper flex px-2 lg:px-0">
        <div className='lg:pl-1 lg:w-[60%]'>
          {/* Price and Location Skeleton */}
          <div className='py-6'>
            <div className="price-container flex items-baseline">
              <div className="h-7 w-24 bg-gray-200 rounded"></div>
              <div className="h-7 w-32 bg-gray-200 rounded ml-2"></div>
            </div>

            <div className="h-5 w-64 bg-gray-200 rounded mt-2"></div>
          </div>

          <hr></hr>
          
          {/* Description Section Skeleton */}
          <div className="pt-6">
            <div className="h-7 w-32 bg-gray-200 rounded"></div>
            <div className="flex flex-col gap-2 py-6">
              <div className="h-4 w-full bg-gray-200 rounded"></div>
              <div className="h-4 w-full bg-gray-200 rounded"></div>
              <div className="h-4 w-3/4 bg-gray-200 rounded"></div>
              <div className="h-4 w-5/6 bg-gray-200 rounded"></div>
              <div className="h-4 w-2/3 bg-gray-200 rounded"></div>
            </div>
          </div>

          <hr></hr>

          {/* Details Section Skeleton */}
          <div>
            <p className="text-xl font-medium py-6">Details</p>

            <div className='pb-6 w-full text-gray-800'>
              <div className='flex flex-col md:flex-row md:flex-wrap'>
                <div className='w-full md:w-1/2'>
                  {/* First column of details */}
                  {[1, 2, 3, 4].map((i) => (
                    <div key={i} className='flex items-center px-2 md:px-0 md:py-0.5'>
                      <div className='w-[40px]'>
                        <div className='flex-shrink-0 size-6 md:size-7 bg-gray-200 rounded-full'></div>
                      </div>
                      <div className='align-middle p-2'>
                        <div className="h-5 w-32 bg-gray-200 rounded"></div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className='w-full md:w-1/2'>
                  {/* Second column of details */}
                  {[1, 2, 3, 4].map((i) => (
                    <div key={i} className='flex items-center px-2 md:px-0 md:py-0.5'>
                      <div className='w-[40px]'>
                        <div className='flex-shrink-0 size-6 md:size-7 bg-gray-200 rounded-full'></div>
                      </div>
                      <div className='align-middle p-2'>
                        <div className="h-5 w-36 bg-gray-200 rounded"></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <hr></hr>

          {/* Mobile Message Box Skeleton (Only visible on mobile) */}
          <div className="block py-6 lg:hidden">
            <div className="h-32 bg-gray-200 rounded-xl"></div>
          </div>

          {/* Map Skeleton */}
          <div className="py-6">
            <div className="h-64 w-full bg-gray-200 rounded-xl mb-2"></div>
            <div className="h-4 w-full md:w-3/4 bg-gray-200 rounded"></div>
          </div>
        </div>

        {/* Desktop Message Box Skeleton */}
        <div className="hidden lg:block floating-box-container w-[38%] py-6 sticky top-20">
          <div className="sticky top-[84px]">
            <div className="h-64 bg-gray-200 rounded-xl"></div>
          </div>
        </div>
      </div>

      <hr></hr>

      {/* Related Listings Skeleton */}
      <div className="pt-6 pb-12">
        <div className="h-7 w-64 bg-gray-200 rounded mb-6"></div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 px-2 md:px-0">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="h-64 bg-gray-200 rounded-xl"></div>
          ))}
        </div>
      </div>

      <hr></hr>
    </div>
  );
};

export default ListingSkeleton;